import './date-picker.scss'

import styled from '@emotion/styled'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useGetByTenantStaticBusinessdatesAndFromToQuery } from 'api/rtk-api'
import { addDays, isSameDay } from 'date-fns'

import { TENANT } from '@/const'

const Wrapper = styled.div`
  input {
    padding: 12px 8px;
    margin: 0;
    box-sizing: border-box;
    color: var(--Graphite);
    border: solid 1px var(--White80);
    vertical-align: middle;
    height: auto;
  }
  .MuiIconButton-root {
    color: var(--Red-Dark);
  }
`

export type BaseProps = {
  disabled?: boolean
  maxDate?: Date | null
  minDate?: Date | null
  onChange: (date?: Date) => void
  shouldDisableDate?: (date: Date) => boolean
  testId?: string
  value: Date | null
}

export const LegacyDatePickerBody = ({
  disabled,
  maxDate,
  minDate,
  onChange,
  shouldDisableDate,
  testId,
  value
}: BaseProps) => (
  <Wrapper data-testid="date-picker">
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        aria-label="change date"
        disabled={disabled}
        format="dd/MM/yyyy"
        maxDate={maxDate}
        minDate={minDate}
        shouldDisableDate={shouldDisableDate}
        slotProps={{
          textField: {
            inputProps: {
              'data-testid': testId
            }
          }
        }}
        value={value}
        onChange={onChange}
      />
    </LocalizationProvider>
  </Wrapper>
)

export const LegacyDatePickerWithoutHolidays = (props: BaseProps) => {
  const { data, isLoading } = useGetByTenantStaticBusinessdatesAndFromToQuery({
    tenant: TENANT,
    from: '2019-01-01',
    to: '2060-01-01'
  })

  if (isLoading || !data) return null

  const { onChange, value } = props
  const valueAsDate = new Date(value)

  if (!data.some(businessDate => isSameDay(valueAsDate, new Date(businessDate)))) {
    onChange(addDays(valueAsDate, 1))
  }

  return (
    <LegacyDatePickerBody
      {...props}
      shouldDisableDate={date => {
        const isBusinessDay = data.some(businessDate => isSameDay(date, new Date(businessDate)))
        return !isBusinessDay
      }}
    />
  )
}

export interface LegacyDatePickerProps extends BaseProps {
  shouldAllowPublicHolidays?: boolean
}
export const LegacyDatePicker = ({
  shouldAllowPublicHolidays = true,
  ...props
}: LegacyDatePickerProps) =>
  shouldAllowPublicHolidays ? (
    <LegacyDatePickerBody {...props} />
  ) : (
    <LegacyDatePickerWithoutHolidays {...props} />
  )
